<template>
  <div class="m-2">
    <div class="row" v-if="currentTab === 'MULTIPLE' && !isShowEachWayMultiple">
      <p class="m-0 d-flex justify-content-end">
        <b>{{ getTranslatedText(`total odds`) }}:&nbsp;
          {{ totalOdds }}
        </b>
      </p>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col-6">
        <b>{{ currentTab === 'SINGLE' ? getTranslatedText(`total stake`) : getTranslatedText(`stake`) }}:</b>
      </div>
      <div class="col-6" v-if="currentTab === 'SINGLE'">
        <div class="d-flex justify-content-end p-2">
          <span><b> {{ currencySymbol }}</b> {{ fixedNumber(totalStake) }}</span>
        </div>
      </div>
      <div class="col-6" v-if="currentTab === 'MULTIPLE'">
        <div class="d-flex align-items-center p-2">
          <b class="text-mobile text-mobile__sum">{{ currencySymbol }}</b>&nbsp;
          <input :min="betMin" :max="betMax != null ? betMax : undefined"
            v-model="localBetAmount"
            @blur="handleBlur"
            class="form-control input_sumAmount" />
        </div>
      </div>
    </div>

    <div class="row" v-if="isShowEachWayMultiple">
      <div class="col-12 d-flex justify-content-end align-items-center">
        <label>{{ getTranslatedText('E/W') }}</label>
        &nbsp;
        <input v-model="localEachWayBetMultiple" type="checkbox" class="form-check-input">
      </div>
    </div>
    <hr />
    <div class="row d-flex align-items-center" v-if="currentTab === 'MULTIPLE'">
      <div class="col-6">
        <b>{{ getTranslatedText(`total stake`) }}</b>
      </div>
      <div class="col-6">
        <div class="d-flex justify-content-end p-2">
          <b>{{ fixedNumber(totalStake) }}</b>
        </div>
      </div>
    </div>

    <div class="row d-flex align-items-center">
      <div class="col-6">
        <b>{{ getTranslatedText(`winning tax`) }}</b>
      </div>
      <div class="col-6">
        <div class="d-flex justify-content-end p-2">
          <b>{{ fixedNumber(winningTax) || 0 }}</b>
        </div>
      </div>
    </div>

    <div class="row d-flex align-items-center">
      <div class="col-6">
        <b>{{ getTranslatedText(`possible winnings`) }}</b>
      </div>
      <div class="col-6">
        <div class="d-flex justify-content-end p-2">
          <b>{{ fixedNumber(possibleWinnings) || 0  }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import { fixedNumber, isValidBetAmount, isStakeInRange, parseStakeAmount } from "@/utils/utils";

export default {
  name: 'BetslipSummary',
  mixins: [languageMixins],
  props: {
    currentTab: {
      type: String,
      required: true
    },
    betAmount: {
      type: [Number, String],
      required: true
    },
  },
  data() {
    return {
      tempValue: this.betAmount
    };
  },
  computed: {
    betMin() {
      return this.$store.state.settings.betMin;
    },
    betMax() {
      return this.$store.state.settings.betMax;
    },
    currencySymbol() {
      return this.$store.state.settings.currencySymbol;
    },
    isShowEachWayMultiple() {
      return this.$store.getters.isShowEachWayMultiple;
    },
    totalStake() {
      return this.$store.getters.totalStake;
    },
    winningTax() {
      return this.$store.getters.totalWinningTax;
    },
    possibleWinnings() {
      return this.$store.getters.totalPossibleWinnings;
    },
    eachWayBetMultiple() {
      return this.$store.state.eachWayBetMultiple;
    },
    totalOdds() {
      return this.$store.getters.totalOdds;
    },

    localEachWayBetMultiple: {
      get() {
        return this.eachWayBetMultiple;
      },
      set(value) {
        this.$emit('change-each-way-multiple', value);
      }
    },
    localBetAmount: {
      get() {
        return this.tempValue;
      },
      set(value) {
        this.tempValue = value;
      }
    }
  },
  watch: {
    betAmount: {
      immediate: true,
      handler(newVal) {
        this.tempValue = newVal;
      }
    }
  },
  methods: {
    handleBlur(event) {
      const numValue = parseStakeAmount(event.target.value);
      if (!isNaN(numValue) && isValidBetAmount(numValue, this.betMin, this.betMax)) {
        // this.$emit('update:bet-amount', numValue);
        this.$emit('change-stake', numValue);
      } else {
        this.tempValue = this.betAmount;
        // this.$emit('update:bet-amount', this.betAmount);
        this.$emit('change-stake', this.betAmount);
      }
    },
    fixedNumber
  }
};
</script>
